<template>
  <v-app>
    <v-container fluid>
      <v-layout row class="mt-4 mb-3">
        <v-toolbar id="header-toolbar" color="primary" fixed dark app>
          <v-toolbar-title class="ml-0 hidden-sm-and-down">
            <img :src="computeLogo" height="46" />
          </v-toolbar-title>
          <div>
            <v-layout row class="layout pl-2 app--page-header">
              <div class="page-header-left">
                <h4 class="pr-3 font-weight-medium">Albo Nazionale Istruttori e Tecnici CSAIN settore Tiro con l'arco</h4>
              </div>
            </v-layout>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-layout>

      <v-layout row wrap justify-left>
        <v-flex>
          <v-layout style="margin: 15px 0px;" row wrap>
            <v-flex style="display: contents;">
              <v-icon v-if="!isMobile" left class="mr-3">search</v-icon>
              <v-flex md3 sm2 class="px-1" style="margin: 10px 0px;">
                <v-autocomplete
                  v-model="filtraSezioni"
                  :items="sezioni"
                  :return-object="false"
                  item-text="Descrizione"
                  item-value="Descrizione"
                  box
                  label="Regione"
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex md3 sm3 class="px-1" style="margin: 10px 0px;">
                <v-text-field v-model="filtraTesto" box label="Cerca" clearable hide-details></v-text-field>
              </v-flex>
              <v-flex style="margin: 10px 7px;" class="text-xs-center">
                <v-btn-toggle v-model="filtraStato" row wrap justify-center flat mandatory>
                  <v-btn flat value="Tutti" color="black">Tutti</v-btn>
                  <v-btn flat value="Tecnici" color="blue">Tecnici</v-btn>
                  <v-btn flat value="Istruttori" color="red">Istruttori</v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex md2 sm3 class="text-xs-center">
                <v-btn @click="loadAlbo()" style="margin-top: 13px;" small color="green white--text"> <v-icon small left color="white">cached</v-icon>Aggiorna </v-btn>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="alboFiltrati"
          :search="filtraTesto"
          :pagination.sync="pagination"
          :custom-sort="customSort"
          :hide-headers="isMobile"
          :class="{ mobile: isMobile }"
          disable-initial-sort
          class="elevation-1 mt-3"
        >
          <template slot="items" slot-scope="props">
            <tr v-if="!isMobile">
              <td bold class="font-weight-bold">{{ props.item.Denominazione }}</td>
              <td bold>{{ props.item.AssociazioneDenominazione }}</td>
              <td bold>{{ props.item.AssociazioneCodice }}</td>
              <td bold>{{ props.item.SezioneDescrizione }}</td>
              <td>{{ props.item.Citta }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.Tecnico" class="text-xs-right">{{ props.item.AbilitazioneTecnico }}</span>
                <br v-if="props.item.Tecnico && props.item.Istruttore" />
                <span v-if="props.item.Istruttore" class="text-xs-right">{{ props.item.AbilitazioneIstruttore }}</span>
              </td>
              <td class="text-xs-center">
                <v-avatar v-if="props.item.Tecnico" size="24" color="blue" small>
                  <span class="white--text xm">T</span>
                </v-avatar>
                <v-avatar v-if="props.item.Istruttore" size="24" color="red" small>
                  <span class="white--text xm">I</span>
                </v-avatar>
              </td>
            </tr>

            <tr v-else style="padding-bottom: 10px;">
              <td>
                <ul class="flex-content">
                  <li style="margin: 5px;" data-label="Denomiazione" bold class="font-weight-bold">{{ props.item.Denominazione }}</li>
                  <li style="margin: 5px;" data-label="Denominazione" bold>{{ props.item.AssociazioneDenominazione }}</li>
                  <li style="margin: 5px;" data-label="Sodalizio" bold>{{ props.item.AssociazioneCodice }}</li>
                  <li style="margin: 5px;" data-label="Regione" bold>{{ props.item.SezioneDescrizione }}</li>
                  <li style="margin: 5px;" data-label="Codice CSAIN">{{ props.item.Citta }}</li>
                  <li style="margin: 5px;" data-label="Abilitazione" class="text-xs-center">
                    <span v-if="props.item.Tecnico" class="text-xs-right">{{ props.item.AbilitazioneTecnico }}</span>
                    <br v-if="props.item.Tecnico && props.item.Istruttore" />
                    <span v-if="props.item.Istruttore" class="text-xs-right">{{ props.item.AbilitazioneIstruttore }}</span>
                  </li>
                  <li data-label="Tipo" class="text-xs-center">
                    <v-avatar v-if="props.item.Tecnico" size="24" color="blue" small>
                      <span class="white--text xm">T</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Istruttore" size="24" color="red" small>
                      <span class="white--text xm">I</span>
                    </v-avatar>
                  </li>
                </ul>
              </td>
            </tr>
          </template>
          <v-layout></v-layout>
          <template slot="no-results">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <template slot="no-data">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <!-- PAGINAZIONE IN TABELLA  -->
          <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
        </v-data-table>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
  import { bus } from '@/main';
  import Util from '@/util';
  import Security from '@/security';
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { callbackify } from 'util';

  export default {
    components: {},
    data() {
      return {
        isMobile: false,
        filtraTesto: '',
        filtraTessere: '',
        filtraSezioni: '',
        filtraStato: 'Tutti',
        selected: [],
        headers: [
          { text: 'Denominazione', sortable: true, value: 'Denominazione' },
          { text: 'Sodalizio', sortable: true, value: 'AssociazioneDenominazione' },
          { text: 'Codice Csain', sortable: true, value: 'AssociazioneCodice' },
          { text: 'Regione', sortable: true, value: 'SezioneDescrizione' },
          {
            text: 'Città',
            sortable: true,
            value: 'Citta',
          },
          { text: 'Abilitazione', sortable: false, value: '' },
          { text: 'Tipo', sortable: false, value: '', width: '100px', align: 'center' },
        ],
        pagination: {
          rowsPerPage: 20,
        },
      };
    },
    computed: {
      ...mapGetters('associatiModule', ['getAlbo']),
      ...mapGetters('sharedModule', ['getSezioni']),
      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },
      computeLogo() {
        return '/logo.svg';
      },
      sezioni() {
        return this.getSezioni;
      },
      albo() {
        return this.getAlbo;
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      alboFiltrati() {
        // filtro in tempo reale
        let associatiList = null;
        associatiList = this.albo;
        return associatiList.filter((i) => {
          if (!this.filtraSezioni && !this.filtraTessere && this.filtraStato == 'Tutti') {
            return true;
          } else if (this.filtraStato != 'Tutti' && !this.filtraTessere && !this.filtraSezioni) {
            switch (this.filtraStato) {
              case 'Tecnici':
                return i.Tecnico == 1;
              case 'Istruttori':
                return i.Istruttore == 1;
              default:
                break;
            }
          }
          if (this.filtraTessere != '' && i.NumeroTessera && this.filtraStato == 'Tutti') {
            return i.NumeroTessera == this.filtraTessere;
          }
          if (this.filtraSezioni != '' && i.SezioneDescrizione && this.filtraStato == 'Tutti') {
            return i.SezioneDescrizione == this.filtraSezioni;
          } else {
            if (i.NumeroTessera && !this.filtraSezioni) {
              switch (this.filtraStato) {
                case 'Tecnici':
                  return i.NumeroTessera == this.filtraTessere && i.Tecnico == 1;
                case 'Istruttori':
                  return i.NumeroTessera == this.filtraTessere && i.Istruttore == 1;
                default:
                  break;
              }
            }
            if (i.SezioneDescrizione && !this.filtraTessere) {
              switch (this.filtraStato) {
                case 'Tecnici':
                  return i.SezioneDescrizione == this.filtraSezioni && i.Tecnico == 1;
                case 'Istruttori':
                  return i.SezioneDescrizione == this.filtraSezioni && i.Istruttore == 1;
                default:
                  break;
              }
            }
          }
          return false;
        });
      },
    },
    watch: {
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            this.isMobile = true;
            break;
          case 'sm':
            this.pagination.rowsPerPage = 10;
            break;
          case 'md':
            this.pagination.rowsPerPage = 15;
            this.isMobile = false;
            break;
          case 'lg':
            this.pagination.rowsPerPage = 20;
            this.isMobile = false;
            break;
          case 'xl':
            this.pagination.rowsPerPage = 25;
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      // vm.loadAlbo();
      vm.loadTipologie().then();

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false;
          break;
      }
    },

    methods: {
      ...mapActions('associatiModule', ['loadAlbo']),
      ...mapActions('sharedModule', ['loadTipologie']),

      formatDate(date) {
        if (date) {
          return new Date(date).toLocaleString().split(',')[0];
        }
      },
      customSort(items, index, isDescending) {
        const compare = new Intl.Collator('it').compare;
        if (index === null) return items;

        return items.sort((a, b) => {
          let sortA = a[index];
          let sortB = b[index];

          if (index == 'Associazione.Denominazione') {
            sortA = a.Associazione.Denominazione;
            sortB = b.Associazione.Denominazione;
          } else if (index == 'Associazione.Sezione.Descrizione') {
            sortA = a.Associazione.Sezione.Descrizione;
            sortB = b.Associazione.Sezione.Descrizione;
          } else if (index == 'IndirizzoCorrispondenza.CittaIndirizzo') {
            sortA = a.IndirizzoCorrispondenza.CittaIndirizzo;
            sortB = b.IndirizzoCorrispondenza.CittaIndirizzo;
          }

          if (isDescending) {
            [sortA, sortB] = [sortB, sortA];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          [sortA, sortB] = [sortA, sortB].map((s) => {
            return (s || '').toString();
          });

          return compare(sortA, sortB);
        });
      },
    },
  };
</script>
